import { HttpStatusCode } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { AuthService } from "@front/m19-services";
import { IAlertComponent, LoginFormComponent, LoginFormValue } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { environment } from "@m19-board/environment";
import { LayoutSelectorService } from "@m19-board/layout-selector.service";
import { Angulartics2 } from "angulartics2";
import { AjaxError } from "rxjs/ajax";

@Component({
  selector: "app-login",
  templateUrl: "login.component.html",
  imports: [TranslocoDirective, IAlertComponent, LoginFormComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly angulartics2 = inject(Angulartics2);
  private readonly layoutSelector = inject(LayoutSelectorService);
  private readonly translocoService = inject(TranslocoService);

  loading = signal(false);
  error = signal<string | null>(null);

  agency = this.layoutSelector.getAgencyName();

  login(formValue: LoginFormValue): void {
    const redirectUrl = this.route.snapshot.queryParams["redirect"] ?? "dashboard";

    if (!formValue) return;
    this.error.set(null);
    this.loading.set(true);
    this.authService
      .doLogin(formValue.email, formValue.password, { name: "autopilot", url: environment.autopilotUrl })
      .subscribe({
        next: () => {
          this.angulartics2.eventTrack.next({
            action: "login_with_password",
            properties: { category: "login", label: "success_" + formValue.email },
          });
          this.router.navigateByUrl(redirectUrl);
        },
        error: (err: AjaxError) => {
          if (err.status === HttpStatusCode.Unauthorized) {
            this.error.set(this.translocoService.translate("login.login_error_message"));
          } else this.error.set(err.message);
          this.loading.set(false);
        },
      });
  }
}
